export let ImageTypes = /*#__PURE__*/function (ImageTypes) {
  ImageTypes["Master"] = "master";
  ImageTypes["Standard"] = "standard";
  ImageTypes["Square"] = "square";
  return ImageTypes;
}({});